// extracted by mini-css-extract-plugin
module.exports = {"root":"_2CXBg","title":"_2BVzl","subtitle":"_33G7C"};